import React from 'react';
import { ObjectFieldTemplateProps } from '@rjsf/utils';

// Replaces RJSF's default <fieldset> root with a <div>.
// Browsers give fieldset min-width:min-content which breaks CSS multi-column
// layouts by expanding the container to fit the widest child.
export const CustomObjectFieldTemplate = ({ properties, title, description }: ObjectFieldTemplateProps) => (
  <div style={{ minWidth: 0, width: '100%' }}>
    {title && <legend style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>{title}</legend>}
    {description}
    {properties.map((prop) => prop.content)}
  </div>
);
